var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.menus && _vm.menus.length)?_c('div',{staticClass:"m-menus"},_vm._l((_vm.menus),function(menu,index){return _c('rn-menu',_vm._b({key:index},'rn-menu',menu,false))}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }